export default {
      id: "add-contributor-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#add-contributor-usage",
      toString: function () {
        return this.url;
      }
    }